import React from "react";
import { FormErrors } from "redux-form";

import { CommentFormData } from "@/mk2/apps/forum/components/CommentCreateEditForm";
import { AvatarImg } from "@/mk2/components/AvatarImg";
import { BtnType } from "@/mk2/components/Btn";
import { Form } from "@/mk2/components/Form";
import { SubmitButton } from "@/mk2/components/forms/SubmitButton";
import { TextareaField } from "@/mk2/components/forms/TextareaField";
import { ComposeToolbar, FIXED } from "@/mk2/containers/Toolbar/Toolbar";
import { ToolbarAdditionalCheckbox } from "@/mk2/containers/Toolbar/ToolbarAdditionalCheckbox";
import { MKReduxFormInjectedProps, mkReduxForm } from "@/mk2/decorators/mkReduxForm";
import { UserEntity } from "@/mk2/schemas";
import {
    ADD_COMMENT,
    BLOGS_POST_FORM_ONE_OF_COMMENT_PHOTO_OR_STICKER_IS_REQUIRED,
    SEND_AS_ADMIN,
    SEND_COMMENT,
} from "@/mk/autogenerated/translation";

import styles from "./MessageForm.mscss";

interface OwnProps {
    requestUser: UserEntity;
    requestUserPermissions: string[];
    initialValues: CommentFormData;
    textareaRef?: (r: HTMLTextAreaElement) => void;

    onSend(commentFd: CommentFormData);
}

type Props = OwnProps;

const validate = (values: CommentFormData): FormErrors<CommentFormData> => {
    const errors: FormErrors<CommentFormData> = {};

    if (!values.text?.trim()?.length && !values.photos?.length && !values.sticker) {
        errors.text = BLOGS_POST_FORM_ONE_OF_COMMENT_PHOTO_OR_STICKER_IS_REQUIRED;
    }

    return errors;
};

class MessageFormComponent extends React.Component<
    Props & MKReduxFormInjectedProps<CommentFormData, Props>
> {
    private emojisConfig = {
        fields: ["text"],
        defaultField: "text",
    };

    private photosConfig = {
        photoType: "comment",
        multiple: false,
        showPhotoCode: false,
    };

    public render() {
        const { requestUser, handleSubmit, form, requestUserPermissions } = this.props;
        const isAdmin = requestUserPermissions.indexOf("forum.can_manage_forum") >= 0;

        return (
            <Form className={styles.MessageForm} onSubmit={handleSubmit}>
                <span className={styles.MessageForm__col1}>
                    <AvatarImg user={requestUser} size={32} />
                </span>

                <div className={styles.MessageForm__col2}>
                    <div className={styles.MessageForm__comment}>
                        <TextareaField
                            name="text"
                            placeholder={ADD_COMMENT}
                            rows={3}
                            textareaRef={this.props.textareaRef}
                            bottomBorder={false}
                            isCompact
                        />
                    </div>

                    <ComposeToolbar
                        formName={form}
                        isFixed={FIXED.NEVER}
                        emojis={this.emojisConfig}
                        photos={this.photosConfig}
                        rightAction={
                            <SubmitButton
                                btnType={BtnType.BzGreen}
                                className={styles.MessageForm__button}
                                label={SEND_COMMENT}
                                formName={form}
                            />
                        }
                        isInBlogs
                        additionalActions={
                            isAdmin && (
                                <ToolbarAdditionalCheckbox
                                    isAdminUI
                                    label={SEND_AS_ADMIN}
                                    name="asAdmin"
                                />
                            )
                        }
                    />
                </div>
            </Form>
        );
    }
}

export const MessageFormFactory = (formName: string) =>
    mkReduxForm<CommentFormData, Props>({
        formName,
        onValidate: validate,
        onSave: (values, props) => props.onSend(values),
    })(MessageFormComponent);
